module.exports = __webpack_public_path__ + "img/bigpack-inactive.ec88b21b.svg";